import { Injectable, ElementRef } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ScrollService {
	private contentElementRef?: ElementRef<HTMLElement>;

	setContentElement(elementRef: ElementRef<HTMLElement>) {
		this.contentElementRef = elementRef;
	}

	scrollContentToTop() {
		if (this.contentElementRef?.nativeElement) {
			this.contentElementRef.nativeElement.scrollTo({ top: 0, behavior: 'instant' });
		} else {
			// Fallback to direct DOM access if ElementRef is not available
			const contentElement = document.querySelector('.content') as HTMLElement;
			if (contentElement) {
				contentElement.scrollTo({ top: 0, behavior: 'instant' });
			}
		}
	}
}
